import React from "react";
import GridRectangle, { GridRectangleItem } from "../../../GridRectangle";

type GridDropdownOverlayProps = {
    style: React.CSSProperties;
    items: GridRectangleItem[];
};

function GridDropdownOverlay({ style, items }: GridDropdownOverlayProps) {
    return (
        <div
            id="clava-dropdown-overlay"
            className="fixed z-50 max-h-96 overflow-y-auto rounded-xl shadow-shadow dark:shadow-shadow-dark drop-shadow-lg bg-bg-secondary dark:bg-bg-secondary-dark border border-light-gray dark:border-light-gray-dark p-2 w-full"
            style={style}
        >
            <GridRectangle
                items={items}
                columns={{
                    mobile: 1,
                    tablet: 1,
                    desktop: 1,
                }}
                loading={false}
                compact
            />
        </div>
    );
}

export default React.memo(GridDropdownOverlay);

